import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import AppWrapper from './components/layout/AppWrapper';

import ReceiverPhoneNumber from './features/receiver/ReceiverPhoneNumber';
import ReceiverNetwork from './features/networks/ReceiverNetwork';
import SelectAmount from './features/product/SelectAmount';
import PaymentMethods from './features/paymentMethods/PaymentMethods';
import PaymentDetails from './features/transfer/PaymentDetails';
import ReceiptDetails from './features/sender/ReceiptDetails';
import ReceiptDetailsTwoFactor from './features/sender/ReceiptDetailsTwoFactor';
import SuccessScreen from './features/step/SuccessScreen';

import ErrorScreen from './features/error/ErrorScreen';
import Loader from './features/loading/Loader';
import { getData } from './lib/api/api';
import { getIfGuestPaymentIsEnabled } from './lib/config';

export default function CurrentStep() {
  const { isError } = useSelector((state) => state.error);
  const [showTopup, setShowTopup] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getData(getIfGuestPaymentIsEnabled);
        const topupEnabled = data.topUpEnabled;

        if (!topupEnabled) {
          window.location.href = `${window.location.origin}/404`;
        } else {
          setShowTopup(true);
        }
      } catch (error) {
        window.location.href = `${window.location.origin}/404`;
      }
    };

    fetchData();

    setShowTopup(true);
  }, []);

  if (isError) {
    return (
      <AppWrapper>
        <ErrorScreen />
      </AppWrapper>
    );
  }

  if (!showTopup) {
    return null;
  }

  return (
    <AppWrapper>
      <ReceiverPhoneNumber />
      <ReceiverNetwork />
      <SelectAmount />
      <PaymentMethods />
      <PaymentDetails />
      <ReceiptDetails />
      <ReceiptDetailsTwoFactor />
      <SuccessScreen />
      <Loader />
      <ErrorScreen />
    </AppWrapper>
  );
}
